export const RETURN_REPORT_ACTION = 'RETURN_REPORT_ACTION'
export const RETURN_REPORT_ACTION_SUCCESS = 'RETURN_REPORT_ACTION_SUCCESS'
export const RETURN_REPORT_ERROR_ACTION = 'RETURN_REPORT_ERROR_ACTION'

